//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TimeFormat {
	Hours = 0,
	Minutes = 1,
	Seconds = 2,
	MilliSeconds = 3
}
